var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('router-view'),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"widgets"},[_c('div',{staticClass:"widgets-wrapper"},[_c('ContractStatsWidget',{attrs:{"title":"Rapport des ventes","period":"current_month","class-name":"fullx"}}),_vm._v(" "),_c('CommissionStatsWidget',{attrs:{"title":"Commissions","period":"current_month","class-name":"fullx"}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e098eea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/serevita/Dashboard.vue
// module id = 567
// module chunks = 0